import React, { useCallback, useEffect, useState } from "react";

import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";
import Development from "./Development";

export default function DevelopmentsList({
  developments,
  selectedId,
  flyTo,
  setSelectedId
}) {
  /**
   * Handle tabbed interactions
   */
  const [activeTab, setActiveTab] = useState(0);

  const handleIndexChange = useCallback(
    index => {
      setActiveTab(index === -1 ? 0 : index);
      if (developments.length > 0 && index !== -1) {
        const { permit_id } = developments[index].properties;
        setSelectedId(permit_id);
      }
    },
    [developments, setSelectedId]
  );

  useEffect(() => {
    const index = developments.findIndex(
      d => d.properties.permit_id === selectedId
    );

    handleIndexChange(index);
  }, [selectedId, developments, handleIndexChange, flyTo]);

  const handleTabChange = index => {
    handleIndexChange(index);
    index !== -1 && flyTo(developments[index]);
  };

  return (
    <>
      {developments && (
        <Box
          // bgcolor="grey600"
          p={0}
          pt={{ md: 10 }}
          width={1}
          display={{ md: "flex" }}
          flexDirection={{ md: "column" }}
          maxHeight="100%"
        >
          <Box
            fontSize={12}
            fontFamily="Gotham, Arial, Helvetica, sans-serif"
            fontWeight="bold"
            color="grey200"
            textAlign="center"
            m={1}
          >
            DEVELOPMENTS ON THIS SITE
          </Box>
          <Tabs
            value={activeTab}
            onChange={(event, index) => handleTabChange(index)}
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            {developments.map(development => (
              <Tab
                label={development.properties.permit_id}
                key={development.properties.permit_id}
              />
            ))}
          </Tabs>
          <SwipeableViews
            style={{ overflowY: "auto" }}
            animateHeight={true}
            index={activeTab}
            onChangeIndex={handleTabChange}
          >
            {developments.map(development => (
              <Development
                key={development.properties.permit_id}
                development={development.properties}
              />
            ))}
          </SwipeableViews>
        </Box>
      )}
    </>
  );
}
